import type { ComponentType, SVGProps } from 'react';
import { IconLucideFolder, IconLucidePlus, IconLucideTrash } from '@wegic/icon';

export interface SidebarItem {
  key: string;
  labelKey: string;
  to: string;
  Icon: ComponentType<SVGProps<SVGSVGElement> & { fontSize?: number | string }>;
}

export interface SidebarSection {
  key: string;
  title?: string;
  items: SidebarItem[];
}

export const SIDEBAR_SECTIONS: SidebarSection[] = [
  {
    key: 'workspace',
    items: [
      {
        key: 'create',
        labelKey: 'workspace.createButton.text',
        to: '/workspace/projects',
        Icon: IconLucidePlus,
      },
      {
        key: 'projects',
        labelKey: 'workspace.sidebar.myProjects',
        to: '/workspace',
        Icon: IconLucideFolder,
      },
      {
        key: 'trash',
        labelKey: 'workspace.sidebar.trash',
        to: '/workspace/trash',
        Icon: IconLucideTrash,
      },
    ],
  },
];

export const SIDEBAR_HOME_LABEL = 'wegic.ai';
